/**
 * custom-cart-actions.js
 *
 * Abordagem Simplificada: Sempre busca /cart.js após adicionar
 * para atualizar o contador, ignorando a seção 'header' da resposta AJAX.
 */

(function() {
  /**
   * Adiciona item via AJAX e atualiza contador/minicart (com fallback para contador).
   */
  async function addItemToCartFromSource(variantId, buttonElement = null) {
    if (!variantId) {
      console.error("addItemToCartFromSource: ID da variante ausente.");
      return;
    }

    let quantity = 1;
    if (buttonElement) {
        const itemElement = buttonElement.closest('li, .product-item, .cart-item');
        const quantityInput = itemElement?.querySelector('input[type="number"][min]');
        if (quantityInput) {
            const parsedQuantity = parseInt(quantityInput.value, 10);
            if (Number.isFinite(parsedQuantity) && parsedQuantity >= 1) { quantity = parsedQuantity; }
            else { console.warn("addItemToCartFromSource: Quantidade inválida, usando 1."); }
        }
    }

    let originalButtonHTML = null;
    if (buttonElement) {
      originalButtonHTML = buttonElement.innerHTML;
      buttonElement.disabled = true;
      buttonElement.innerHTML = '<i class="fas fa-spinner fa-spin" style="margin-right: 5px;"></i> Adicionando...';
    }

    // Apenas o ID do mini-cart é estritamente necessário agora para atualizar seu conteúdo.
    const miniCartSectionId = 'mini-cart';
    // Não precisamos mais depender tanto da seção 'header' na resposta.
    const headerSectionId = 'header'; // Mantido na requisição por boas práticas, mas não usado para contador.

    try {
      console.log(`Adicionando variante ${variantId} (Qtd: ${quantity}) ao carrinho...`);
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: quantity }],
          // Ainda pedimos as seções para atualizar o mini-cart corretamente
          sections: [miniCartSectionId, headerSectionId],
          sections_url: window.location.pathname
        })
      });

      const data = await response.json();

      if (!response.ok || (data.status && data.status !== 200)) {
        throw new Error(data.description || data.message || 'Erro ao adicionar item ao carrinho.');
      }

      // --- Sucesso ---
      console.log("Item adicionado com sucesso (resposta add.js):", data);
      showCartAddNotificationGeneric("Produto adicionado ao carrinho!");

      // --- Atualização do Contador (SEMPRE via fetch separado) ---
      console.log("Chamando fetchCartDataAndUpdateCounter após sucesso.");
      fetchCartDataAndUpdateCounter(); // Chama a função que busca /cart.js e atualiza o span

      // --- Atualização do Mini-Cart (se seção foi recebida) ---
      if (data.sections && data.sections[miniCartSectionId]) {
        const newMiniCartHtml = data.sections[miniCartSectionId];
        const miniCartElement = document.getElementById(miniCartSectionId);
        if (miniCartElement) {
          console.log("Atualizando conteúdo interno do mini-cart (#" + miniCartSectionId + ")");
          const parser = new DOMParser();
          const newDoc = parser.parseFromString(newMiniCartHtml, 'text/html');
          const newCartContentInner = newDoc.querySelector(`#${miniCartSectionId}`)?.innerHTML;
          if (newCartContentInner) {
            miniCartElement.innerHTML = newCartContentInner;
            console.log("Conteúdo interno do Mini-Cart (#" + miniCartSectionId + ") atualizado.");
            miniCartElement.dispatchEvent(new CustomEvent('internal-content-updated', { bubbles: false }));
            if (typeof window.initializeWishlistButtons === 'function') {
                 console.log("Re-inicializando botões da wishlist dentro do mini-cart...");
                 setTimeout(window.initializeWishlistButtons, 100);
            }
          } else {
             console.warn(`Não foi possível encontrar o conteúdo interno (#${miniCartSectionId}) no HTML da seção recebida.`);
          }
        } else {
            console.warn(`Elemento do Mini-Cart (#${miniCartSectionId}) não encontrado na página.`);
        }
      } else {
          console.warn(`Seção do Mini-Cart (${miniCartSectionId}) não encontrada na resposta AJAX.`);
      }

      // --- Disparar Evento Genérico ---
      // Pode ser útil para outros scripts, mas não passa mais o 'cart' da resposta add.js
      console.log("Disparando evento 'cart:updated'.");
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

      // --- Remover da Wishlist (Opcional) ---
       if (buttonElement && buttonElement.closest('#wishlist-items') && typeof window.removeFromWishlist === 'function') {
           console.log(`Removendo item ${variantId} da wishlist UI/State após adição ao carrinho.`);
           setTimeout(() => { window.removeFromWishlist(variantId, false); }, 300);
       }

    } catch (error) {
      console.error('Erro em addItemToCartFromSource:', error);
      if (buttonElement) {
        buttonElement.innerHTML = '<i class="fas fa-exclamation-circle" style="margin-right: 5px;"></i> Erro!';
        setTimeout(() => {
          if (document.body.contains(buttonElement)) {
              buttonElement.innerHTML = originalButtonHTML;
              buttonElement.disabled = false;
          }
        }, 2500);
      }
      showCartAddNotificationGeneric(error.message || "Erro ao adicionar.", true);

    } finally {
       if (buttonElement && document.body.contains(buttonElement)) {
            setTimeout(() => {
                if (buttonElement.disabled) {
                     buttonElement.innerHTML = originalButtonHTML;
                     buttonElement.disabled = false;
                }
            }, 400);
       }
    }
  }

  // --- Funções Auxiliares ---

  /**
   * Busca os dados completos do carrinho via /cart.js E ATUALIZA o contador.
   */
  async function fetchCartDataAndUpdateCounter() {
    console.log("Executando fetchCartDataAndUpdateCounter...");
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) throw new Error('Erro ao buscar dados do carrinho (/cart.js).');
      const cartData = await response.json();
      console.log("Dados do carrinho recebidos (/cart.js):", cartData);
      // Chama a função que atualiza o DOM do contador com o item_count recebido
      updateCartCounter(cartData.item_count);
    } catch (error) {
      console.error("fetchCartDataAndUpdateCounter Error:", error);
      updateCartCounter(0); // Define como 0 em caso de erro
    }
  }

  /**
   * Atualiza o(s) SPAN(s) do contador na página com um valor numérico (COM DELAY).
   */
  function updateCartCounter(count) {
      // !! GARANTA QUE ESTE SELETOR CORRESPONDE AO SEU header.liquid !!
      const selectors = [ 'cart-count.header__cart-count span.cart-count__value' ];
      const numericCount = Number.isFinite(Number(count)) ? Number(count) : 0;

      console.log(`updateCartCounter: Agendando atualização para: ${numericCount}`);
      let updated = false;

      // Adiciona o delay antes de tentar atualizar o DOM
      setTimeout(() => {
          console.log(`updateCartCounter (Delayed): Tentando atualizar para ${numericCount}`);
          selectors.forEach(selector => {
              const countElements = document.querySelectorAll(selector);
              console.log(`[PAGINA - Delayed] Procurando por '${selector}'. Encontrados: ${countElements.length}`);
              if (countElements.length > 0) {
                  updated = true;
                  countElements.forEach(el => {
                      console.log(`[PAGINA - Delayed] ATUALIZANDO elemento com valor: ${numericCount}`);
                      el.textContent = numericCount;
                      const cartCountWrapper = el.closest('cart-count.header__cart-count');
                      if (cartCountWrapper) {
                          const cartIconWrapper = cartCountWrapper.closest('.header__custom-button--cart');
                          if (cartIconWrapper) {
                              cartIconWrapper.classList.toggle('cart--empty', numericCount === 0);
                          }
                      }
                  });
              }
          });
          if (!updated) {
              console.warn("Nenhum elemento contador (span.cart-count__value) encontrado na página (APÓS DELAY) com os seletores fornecidos em updateCartCounter.");
          }
      }, 150); // Aumentei ligeiramente o delay para 150ms, como teste.
  }

  // Removida a função updateCartCounterFromHtml, pois não será mais usada.

  /**
   * Mostra uma notificação genérica (sucesso ou erro).
   */
  function showCartAddNotificationGeneric(message, isError = false) {
    const notification = document.getElementById('cart-add-notification');
    if (!notification) { console.warn("#cart-add-notification não encontrado."); return; }
    const notificationText = notification.querySelector('span');
    const iconElement = notification.querySelector('.notification-icon');
    if (!notificationText) { console.warn("Span dentro de #cart-add-notification não encontrado."); notification.textContent = message; }
    else { notificationText.textContent = message; }
    if (isError) {
      if (iconElement) iconElement.className = 'notification-icon fas fa-times-circle';
      notification.style.background = 'rgba(220, 53, 69, 0.95)';
       notification.classList.add('error'); notification.classList.remove('success');
    } else {
      if (iconElement) iconElement.className = 'notification-icon fas fa-check-circle';
      notification.style.background = 'rgba(40, 167, 69, 0.95)';
       notification.classList.add('success'); notification.classList.remove('error');
    }
    notification.style.display = 'flex';
    void notification.offsetWidth;
    notification.classList.add('show');
    let currentTimeout = notification.dataset.hideTimeout;
    if (currentTimeout) clearTimeout(parseInt(currentTimeout));
    notification.dataset.hideTimeout = setTimeout(() => {
      notification.classList.remove('show');
      notification.addEventListener('transitionend', () => {
         if (!notification.classList.contains('show')) {
            notification.style.display = 'none';
            notification.classList.remove('success', 'error');
         }
      }, { once: true });
    }, 3000);
  }

  // --- Inicialização e Exposição Global ---
   document.addEventListener('DOMContentLoaded', () => {
       window.addItemToCartFromSource = addItemToCartFromSource;
       console.log("custom-cart-actions.js (v. Simplificada) carregado.");

       // Chamada inicial para garantir que o contador esteja correto ao carregar
       fetchCartDataAndUpdateCounter();
   });

})(); // Fim do IIFE